module.exports = __webpack_public_path__ + "img/people-with-thumbs-up.fe76d486.svg";